import { booleanAttribute, Directive, HostBinding, Input } from '@angular/core'

@Directive({ selector: 'button[appButton]' })
export class ButtonDirective {

    @HostBinding('class.app-button')
    public baseClass: boolean = true

    @Input()
    public theme: 'primary' | 'secondary' | 'warn' | 'light' | '' | null | undefined = 'primary'

    @HostBinding('class.app-button__size-small')
    @Input({ transform: booleanAttribute })
    public small: boolean = false

    @HostBinding('class.app-button__full-width')
    @Input({ transform: booleanAttribute })
    public fullwidth: boolean = false

    @HostBinding('class.app-button__icon-only')
    @Input({ transform: booleanAttribute })
    public iconOnly: boolean = false

    // ------------------------------------------------------------------------------
    //      Theme class switches
    // ------------------------------------------------------------------------------

    @HostBinding('class.app-button__theme-primary')
    public get isThemePrimary(): boolean {
        return this.theme === 'primary'
    }

    @HostBinding('class.app-button__theme-secondary')
    public get isThemeSecondary(): boolean {
        return this.theme === 'secondary'
    }

    @HostBinding('class.app-button__theme-light')
    public get isThemeLight(): boolean {
        return this.theme === 'light'
    }

    @HostBinding('class.app-button__theme-warn')
    public get isThemeWarn(): boolean {
        return this.theme === 'warn'
    }
}
